import LocalLogRecord from "./LocalLogRecord";

export default class LocalLogStore {

    private readonly storeSize: number = 1000;

    constructor(storeSize: number = 1000) {
        this.storeSize = storeSize;
    }

    public logMessages: LocalLogRecord[] = [];

    public addMessage = (msg: string) => {
        const record = new LocalLogRecord();
        record.message = msg;
        record.messageDate = new Date();
        this.logMessages.push(record);
        if(this.logMessages.length > this.storeSize) {
            this.logMessages = this.logMessages.slice(1);
        }
    }

}


// WEBPACK FOOTER //
// ./src/logging/LocalLogStore.ts